import { FadeTransition } from './FadeTransition';

export default FadeTransition;
